var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatarArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.31 13.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "avatar_arrows") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-26.14,228.22h-3c-1.12,0-2,.69-2,1.53v2.91a1.67,1.67,0,0,0,1.48,1.46v3.26h1v-3.95h-.46c-.57,0-1-.35-1-.77v-2.91c0-.43.46-.77,1-.77h3c.57,0,1,.34,1,.77v2.91c0,.42-.46.77-1,.77h-.46v3.95h1v-3.26a1.67,1.67,0,0,0,1.48-1.46v-2.91c0-.84-.91-1.53-2-1.53",
    transform: "translate(36.78 -223.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-18.47,231a.33.33,0,0,0-.15-.27l-1.61-1.21h0l0,0a.62.62,0,0,0-.71,0,.32.32,0,0,0,0,.53l.81.61h-2.19c-.28,0-.5.16-.5.37s.22.38.5.38h2.18l-.75.57a.31.31,0,0,0,0,.53.61.61,0,0,0,.35.11.64.64,0,0,0,.36-.11l1.6-1.21a.31.31,0,0,0,.15-.27",
    transform: "translate(36.78 -223.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-32.89,230.6h-2.19l.81-.61a.32.32,0,0,0,0-.53.65.65,0,0,0-.71,0l0,0h0l-1.57,1.18h0l0,0a.43.43,0,0,0-.14.2.33.33,0,0,0,.14.34l1.6,1.21a.64.64,0,0,0,.36.11.58.58,0,0,0,.35-.11.31.31,0,0,0,0-.53l-.75-.57h2.18c.28,0,.5-.17.5-.38s-.22-.37-.5-.37",
    transform: "translate(36.78 -223.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-27.63,226.7c-.74,0-1.35-.46-1.35-1s.61-1,1.35-1,1.36.46,1.36,1-.61,1-1.36,1m0-2.79c-1.3,0-2.36.79-2.36,1.77s1.06,1.77,2.36,1.77,2.36-.79,2.36-1.77-1.05-1.77-2.36-1.77",
    transform: "translate(36.78 -223.91)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarArrows);
export default __webpack_public_path__ + "static/media/avatar_arrows.d83db1f0.svg";
export { ForwardRef as ReactComponent };